export function getEnv(variable: string): object|string|null {
	if (variable) {
		if (hasNodeEnv(variable)) {
			return getEnvNode(variable);
		}

		if (hasAstroEnv(variable)) {
			return getEnvAstro(variable);
		}
	}

	console.info('env not found: ' + variable);
	return null;
}

export function getAllEnv(): object {
	let toReturn = {};

	if (typeof getEnvAstro() === 'object') {
		toReturn = {
			...toReturn,
			...getEnvAstro()
		};
	}

	if (typeof getEnvNode() === 'object') {
		toReturn = {
			...toReturn,
			...getEnvNode()
		};
	}

	return toReturn;
}

export function getEnvNode(variable: string|null = null): object|string|null {
	if (typeof process === 'object' && variable === null) {
		return process.env;
	}
	if (hasNodeEnv(variable)) {
		return process.env[variable];
	}
	return null;
}

export function getEnvAstro(variable: string|null = null): object|string|null {
	if (variable === null) {
		return import.meta.env;
	}
	if (hasAstroEnv(variable)) {
		return import.meta.env[variable];
	}
	return null;
}

export function hasEnv(variable: string): boolean {
	return hasNodeEnv(variable) || hasAstroEnv(variable);
}

export function hasNodeEnv(variable: string) {
	if (typeof process === 'object' && typeof process.env === 'object') {
		if (process.env.hasOwnProperty(variable)) {
			return true;
		}
	}
	return false;
}

export function hasAstroEnv(variable: string){
	if (typeof import.meta === 'object' && typeof import.meta.env === 'object') {
		if (import.meta.env[variable]) {
			return true;
		}
	}
	return false;
}
